// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'tableControls';
export const selectControlsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  collapsed: false,
  selectedPlayers: [],
  weeks: [],
};

const tableControlsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default tableControlsReducer;

// ------------------------------------
// Rest of your logic goes here
// Use action or aaction snippets
// ------------------------------------

export const COLLAPSE_TABLES = `${STORE_KEY}/COLLAPSE_TABLES`;
export const collapseTables = () => ({ type: COLLAPSE_TABLES });
actions[COLLAPSE_TABLES] = state => ({ ...state,
  collapsed: true,
});

export const EXPAND_TABLES = `${STORE_KEY}/EXPAND_TABLES`;
export const expandTables = () => ({ type: EXPAND_TABLES });
actions[EXPAND_TABLES] = state => ({ ...state,
  collapsed: false,
});

// ------------------------------------
// Jump to week
// ------------------------------------

export const JUMP_TO_WEEK = `${STORE_KEY}/JUMP_TO_WEEK`;
export const jumpToWeek = week => ({
  type: JUMP_TO_WEEK,
  payload: week,
});
actions[JUMP_TO_WEEK] = (state, { payload: week }) => ({ ...state, week: value})


// ------------------------------------
// Update Tracking List
// ------------------------------------
export const TOGGLE_SELECTED_PLAYER = `${STORE_KEY}/TOGGLE_SELECTED_PLAYER`;
export const toggleSelectedPlayer = player => ({
  type: TOGGLE_SELECTED_PLAYER,
  payload: { player },
});
actions[TOGGLE_SELECTED_PLAYER] = (state, { payload: { player } }) => {
  const isTeam = player.player_id == null;
  const isSelected = isTeam ? !!state.selectedPlayers.find(
    selected => selected.team_id === player.team_id,
  ) : !!state.selectedPlayers.find(
    selected => selected.player_id === player.player_id,
  );

  return ({ ...state,
    selectedPlayers: isTeam ? isSelected
      ? state.selectedPlayers.filter(selected => selected.team_id !== player.team_id)
      : state.selectedPlayers.concat(player) : isSelected
      ? state.selectedPlayers.filter(selected => selected.player_id !== player.player_id)
      : state.selectedPlayers.concat(player),
  });
};


// ------------------------------------
// Clear all selected players
// ------------------------------------
export const CLEAR_SELECTED_PLAYERS = `${STORE_KEY}/CLEAR_SELECTED_PLAYERS`;
export const clearSelectedPlayers = () => ({ type: CLEAR_SELECTED_PLAYERS });
actions[CLEAR_SELECTED_PLAYERS] = state => ({ ...state,
  selectedPlayers: [],
});



// WEBPACK FOOTER //
// ./src/store/reducers/tableControls.js